import React from 'react';
import LanguageBtn from '../Components/LanguageBtn/LanguageBtn';
import ThemeBtn from '../Components/ThemeBtn';
import PoemCard from '../Components/PoemCard/PoemCard';
import Header from '../Components/Header/Header';
import { valentinesConfetti } from '../Components/ConfettiConfig/ConfettiConfig';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setTheme } from '../Redux/themeSlice';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { setFormData } from '../Redux/formSlice';
import { useTranslation } from 'react-i18next'
import Footer from '../Components/Footer/Footer';

function Formulario(props) {
  const region = useSelector((state) => state.region.region);
  const theme = useSelector((state) => state.theme.theme);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  const [fullName, setFullName] = useState(''); 
  const [email, setEmail] = useState(''); 
  const [age, setAge] = useState(''); 

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isFormValid = () => {
    return fullName.trim() !== '' && validateEmail(email) && age.trim() !== '';
  };

  const handleContinue = (e) => {
    if (!isFormValid()) {
      e.preventDefault();
    } else {
      dispatch(setFormData({ fullName, email, age }));
    }
  };

  return (
    <>
      <div className="container content-container">
        <Header />
        <div className="row justify-content-end">
          <div className="col-12 d-flex justify-content-end mt-40">
            <LanguageBtn />
          </div>
        </div> 
        <div className="row mt-80 justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card-theme">
              <div className="row">
                <div className="col-12">
                  <h5 className='hero-section-desc'>
                    {t('form_description')}
                  </h5>
                </div>
              </div>
              <div className="row mt-24">
              <div className="col-12">
                  <label>{t('full_name')} <span>*</span></label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder={t('full_name')}
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>
                <div className="col-8">
                  <label>{t('email')} <span>*</span></label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder={t('email')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="col-4">
                  <label>{t('age')} <span>*</span></label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder={t('age')}
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                  />
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-12 col-md-6 select-theme-div ">
                  {isFormValid() ? (
                    <Link to="/Chat" onClick={handleContinue}>
                      <button className="btn btn-primary">
                        {t('continue')}
                      </button>
                    </Link>
                  ) : (
                    <button className="btn btn-primary disabled" disabled>
                      {t('continue')}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*
        <div className="row mt-40 mx-5">
          <div className="col-6 mt-40">
            <div className='card'>
              <p>
                Do you like this idea?
              </p>
              <div className="row">
                <div className="col-12 col-md-6 d-flex h-auto mt-16">
                  <button className="btn -secondary">
                    Generate another thought
                  </button>
                </div>
                <div className="col-12 col-md-6 d-flex h-auto mt-16">
                  <button className="btn -secondary">
                    Generate other gifts
                  </button>
                </div>
                <div className="col-12 d-flex h-auto mt-16">
                  <button
                    className="btn -primary w-100"
                    onClick={() => {
                      handleConfetti();
                    }}>
                      I love it!
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6 mt-40">
            <div className='card'>
              <label for="customRange1" class="form-label">Expected budget range</label>
              <input type="range" class="form-range" id="customRange1" />
            </div>
          </div>
          <div className="col mt-40">
            <button className="-primary -icon">
              <i class="fa-solid fa-share"></i>
            </button>
          </div>
        </div>
        */}
        {/*
        <div className="row mt-40 mb-120 mx-5">
          <PoemCard />
        </div>
        */}
      </div>
      <div className='mt-120'>
        <Footer region={region}/>
      </div>
    </>
  );
}

export default Formulario;